module.exports = __webpack_public_path__ + "static/media/singleImage.8e39bd4e.png";